<template>
  <v-app>
    <router-view/>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // Проверяем, открыта ли новая сессия браузера
    if (!sessionStorage.getItem('session_started')) {
      // Это новая сессия браузера
      sessionStorage.setItem('session_started', 'true');      
      // Очищаем cookie при старте новой сессии
      this.clearCookies();
    }
  }, 
  data: () => ({
    //
  }),
  methods: {
    clearCookies() {      
      // Устанавливаем каждую cookie с истекшим сроком действия
      // Удаляем только cookie с именем 'accept'
      document.cookie = 'accept=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'accept=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + window.location.hostname;
    }
  }
}
</script>
